import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

// A hint centred over the map. It hides on the first press anywhere outside
// it, which is how "Click to start drawing" gets out of the way once the user
// starts drawing, and shows again whenever `showPopup` changes.
const PropertyPopup = ({ ariaLabel, msg, showPopup }) => {
  const [visible, setVisible] = useState(showPopup);
  const labelRef = useRef(null);

  useEffect(() => {
    setVisible(showPopup);
    const hideOnOutsidePress = event => {
      if (!labelRef.current?.contains(event.target)) {
        setVisible(false);
      }
    };
    document.addEventListener('mousedown', hideOnOutsidePress);
    return () => document.removeEventListener('mousedown', hideOnOutsidePress);
  }, [showPopup]);

  return (
    <div className="absolute" style={{ left: '50%', top: '50%' }}>
      {visible && (
        <div
          ref={labelRef}
          aria-label={ariaLabel}
          className="absolute z-50 p-3 text-xl text-white bg-black rounded shadow-lg whitespace-nowrap"
          style={{ left: '50%', transform: 'translateX(-50%)' }}
        >
          {msg}
        </div>
      )}
    </div>
  );
};

PropertyPopup.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  msg: PropTypes.string.isRequired,
  showPopup: PropTypes.bool.isRequired
};

export default PropertyPopup;
